import React from 'react'

import { ReactComponent as UserDoctor } from '../../../../../assets/icons/user-doctor.svg'
import * as S from './styles'

const ProfileInfo = ({ professional }) => {
  return <>
    <S.Container>
      <S.WrapperUserData>
        <UserDoctor />
        <S.WrapperText>
          <S.DoctorName>{professional.name}</S.DoctorName>
          <S.DoctorCnpj>CNPJ {professional.cnpj}</S.DoctorCnpj>
        </S.WrapperText>
      </S.WrapperUserData>
    </S.Container>
  </>
}

export default ProfileInfo
